import React, { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { authHeader } from "../../utils/authHeader";
import { API_BASE_URL, urlDeArchivo } from "../../config";

import Brightness4Icon from "@mui/icons-material/Brightness4";
import ExitToAppOutlinedIcon from "@mui/icons-material/ExitToAppOutlined";

import NomIcon from "./../../assets/icon/Heinsson.png";
import InstaIcon from "./../../assets/icon/insta.png";
import WhatsAppIcon from "./../../assets/icon/wp.png";
import CompensarIcon from "./../../assets/icon/compensar.webp";
import LinkedInIcon from "./../../assets/icon/linkedin.png";
import Shop from "./../../assets/icon/shop.png";
import sharepoint from "./../../assets/icon/Sharepoint.png";

import MenuLink from "../menuLink/MenuLink";
import MenuLink2 from "../menuLink/MenuLink2";
import { DarkModeContext } from "./../../context/darkModeContext";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase";

import "./sidebar.scss";

// ✅ Sidebar con efectos modernos
const Sidebar = ({ showSidebarMobile, toggleSidebar, setView }) => {
  const { dispatch } = useContext(DarkModeContext);
  const { spaceId } = useParams();
  const [spaces, setSpaces] = useState([]);
  const [selectedSpace, setSelectedSpace] = useState(null);

  useEffect(() => {
    const fetchSpaces = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/spaces`, {
          headers: { ...authHeader() },
        });
        setSpaces(res.data.spaces);
        if (spaceId) {
          const found = res.data.spaces.find(
            (s) => s.id === parseInt(spaceId)
          );
          setSelectedSpace(found);
        }
      } catch (err) {
        console.error("Error al cargar espacios:", err);
      }
    };
    fetchSpaces();
  }, [spaceId]);

  return (
    <>
      {showSidebarMobile && (
        <div className="sidebarOverlay" onClick={toggleSidebar} />
      )}
      <div className={`sidebar ${showSidebarMobile ? "showMobile" : ""}`}>
        <div className="sidebarWrapper">
          {/* ✅ Botón para cerrar en móviles */}
          <button className="closeSidebarBtn" onClick={toggleSidebar}>
            ✕ Cerrar
          </button>

          <span onClick={() => dispatch({ type: "TOGGLE" })}>
            <MenuLink Icon={<Brightness4Icon />} text="Tema" />
          </span>
          <span onClick={() => signOut(auth)}>
          <MenuLink Icon={<ExitToAppOutlinedIcon />} text="Cerrar sesión" />
        </span>

        <hr className="sidebarHr" />
        <span className="navbarLink">Accesos Directos</span>
          <MenuLink2
          Icon={Shop}
          text="Tienda Virtual"
          href="https://assamas.assaabloy.net/feriaempleados"
        />
        <MenuLink2
          Icon={sharepoint}
          text="ASSA ABLOY COLOMBIA - Homepage"
          href="https://assaabloy.sharepoint.com/sites/AMER-ASSAABLOYCOLOMBIA?CT=1764710116303&OR=OWA-NT-Mail&CID=44f2c24a-d8dc-b6f4-6a64-1f4d6e15c3d5"
        />
        <MenuLink2
          Icon={NomIcon}
          text="Nómina, Incapacidades, Certificaciones"
          href="https://nominasaas15.heinsohn.com.co/NominaWEB/common/mainPages/login.seam?cid=296"
        />
        <MenuLink2
          Icon={CompensarIcon}
          text="Convenios Compensar"
          href="https://corporativo.compensar.com/descuentos-beneficios"
        />
        <MenuLink2
          Icon={InstaIcon}
          text="Assa Abloy Colombia"
          href="https://www.instagram.com/assaabloycol/"
        />
        <MenuLink2
          Icon={WhatsAppIcon}
          text="Comunidad Colombia"
          href="https://chat.whatsapp.com/KawjwncFit7GKtscGjHheJ"
        />
        <MenuLink2
          Icon={CompensarIcon}
          text="Club de Bienestar Compensar"
          href="https://www.tiendacompensar.com/"
        />
        <MenuLink2
          Icon={LinkedInIcon}
          text="Assa Abloy Colombia LinkedIn"
          href="https://co.linkedin.com/company/assa-abloy-colombia"
        />

        <span className="navbarLink">Espacios</span>
        {spaces.map((space) => (
          <Link
            key={space.id}
            to={`/space/${space.id}`}
            style={{ textDecoration: "none", color: "inherit" }}
            onClick={() => {
              setView("feed");
              toggleSidebar();
            }}
          >
            <MenuLink
              Icon={
                <img
                  src={urlDeArchivo(space.image) || "/default-icon.png"}
                  alt=""
                  style={{ width: 24, height: 24, borderRadius: "50%" }}
                />
              }
              text={space.name}
            />
          </Link>
        ))}
        </div>
      </div>
    </>
  );
};

export default Sidebar;
